const EnglishLanguage = [
   {
      about:"About",
   },
   {
      service:"Services",
   },
   {
      projects:"Projects",
   },
   {
      design:"Design",
   },
   {
      develop:"Develop",
   },
   {
      and:"&",
   },
   {
      create:'Create Webpages'
   },
   {
      software:'Software'
   },
   {
      system:'Systems'
   },
   {
      uniqueDesign :'Unique Layout Design',
   },
   {
      responsive :'Responsive With All Devices',
   },
   {
      support :'24/7 Hours Dedicated Support',
   },
   {
      platforms :'Platforms',
   },
   {
      commerce :'E-commerce',
   },
   {
      custom :'Custom Design',
   },
   {
      systemsAnalysis :'Systems',
   },
   {
      demosTitle :'We specialize in enhancing the world around us, Explore it now.',
   },
   {
      clientsTitle :'We have earned the trust of esteemed clients.',
   },
];
export default EnglishLanguage